<template>
  <div class="page">
    <!-- 头部 start -->
    <Head :tabIndex="0"></Head>
    <!-- 头部 end -->
    <!-- 订单查询 start -->
    <div class="tracking">Consignment Tracking</div>
    <div class="Search-wrap">
      <el-input v-model="order_no" class="Search" placeholder="Search Reference Number">
        <el-button slot="append" @click="orderTrajectory" class="TRACK">TRACK</el-button>
      </el-input>
    </div>
    <!-- 订单查询 end -->

    <!-- 物流状态 start -->
    <div class="list" v-loading="loading">
      <div class="list-title" v-if="detail.length!=0">Tracking Details</div>
      <div v-for="(ele,i) in detail" :key="i" style="margin-top: 30px;">
        <div class="list-title" v-if="detail.length!=0">{{ele.order_no}}</div>
        <div class="item" :class="{itemActive:viewPODV == index&&item.status == 23}" v-for="(item,index) in ele.trajectory" :key="index">
          <div class="item-list">
            <div class="item-left">
              <img class="item-left-solid" v-if="index!=0" src="../../static/order/s8.png">
              <div class="item-left-tex-wrap">
                <!-- <img class="item-left-text item-left-one" v-if="item." :src="item.img"> -->
                <img v-if="item.status == 0" class="item-left-text item-left-one" src="../../static/order/s1.png">
                <img v-if="item.status == 1" class="item-left-text item-left-one" src="../../static/order/s9.png">
                <img v-if="item.status == 21" class="item-left-text item-left-one" src="../../static/order/s11.png">
                <img v-if="item.status == 22" class="item-left-text item-left-one" src="../../static/order/s2.png">
                <img v-if="item.status == 23&&!item.problem_type" class="item-left-text item-left-one" src="../../static/order/s4.png">
                <img v-if="item.status == 23&&item.problem_type" class="item-left-text item-left-one" src="../../static/order/s10.png">
                <img v-if="item.status == 3" class="item-left-text item-left-one" src="../../static/order/s6.png">
                <img v-if="item.status == 4" class="item-left-text item-left-one" src="../../static/order/s7.png">
              </div>
              <div v-if="item.status == 0" class="item-right-title">Shipment created</div>
              <div v-if="item.status == 1" class="item-right-title">Warehouse checkin</div>
              <div v-if="item.status == 21" class="item-right-title">Loading goods</div>
              <div v-if="item.status == 22" class="item-right-title">In Transit</div>
              <div v-if="item.status == 23&&!item.problem_type" class="item-right-title">Goods arrived</div>
              <div v-if="item.status == 23&&item.problem_type" class="item-right-title">Abnormal</div>
              <div v-if="item.status == 3" class="item-right-title">Delivered</div>
              <div v-if="item.status == 4" class="item-right-title">Cancelled</div>
            </div>
            <div class="item-right">
              <div class="order-time">{{item.time}}</div>
              <div class="order-no" v-if="item.status == 0">In system</div>
              <div class="order-no" v-if="item.status == 1">{{ele.from_area}}</div>
              <div class="order-no" v-if="item.status == 21">{{ele.from_area}}</div>
              <div class="order-no" v-if="item.status == 22">{{ele.to_area}}</div>
              <div class="order-no" v-if="item.status == 23&&item.problem_type">{{item.problem_type}}</div>
              <div @click="PODV(index)" class="order-no" v-if="item.status == 23&&!item.problem_type"><span>POD</span><img class="jiantou"
                  :class="{jiantouActive:viewPODV==index}" src="../../static/order/xia.png"></div>
                  <div class="order-no" v-if="item.status == 3"></div>
                  <div class="order-no" v-if="item.status == 4"></div>
            </div>
          </div>
          <template v-if="item.sign_user_img">
            <viewer v-show="viewImg" :images="[item.sign_user_img]">
              <img class="item-img-pre" fit="cover" v-for="(item,index) in [item.sign_user_img]" :src="item" :key="index">
            </viewer>
          </template>
        </div>
      </div>
    </div>
    <!-- 物流状态 end -->
    <el-image-viewer v-if="showViewer" :on-close="()=>{showViewer=false}" :url-list="imgList" />
  </div>
</template>

<script>
  export default {
    data() {
      return {
        viewImg: false,
        viewPODV: "",
        loading: false,
        showViewer: false,
        imgList: [],
        order_no: "",
        dataList: [],
        detail:[]
      }
    },
    mounted() {
      document.title = 'Order No.-TE EXPRESS';
      if (this.$route.query.order_no) {
        this.order_no = this.$route.query.order_no;
      }
      this.orderTrajectory();
    },
    methods: {
      PODV(index) {
        if (this.viewPODV != index) {
          this.viewPODV = index;
          setTimeout(() => {
            this.viewImg = true;
          }, 300)
        } else {
          this.viewPODV = "";
          this.viewImg = false;
        }
      },
      preview(arr) {
        this.imgList = arr;
        this.showViewer = true;
      },
      orderTrajectory() {
        if (this.order_no == "") {
          this.$message({
            message: "Order No. cannot be blank",
            type: 'wraning'
          })
          return false;
        }
        this.loading = true;
        this.detail = [];
        this.viewImg = false;
        this.viewPODV = "";
        this.$axios({
          method: 'post',
          url: this.$host + this.$api.orderTrajectory,
          headers: {
            lang: 'en'
          },
          data: {
            order_no: this.order_no
          }
        }).then(res => {
          if (res.data.code == 1) {
            // 创建订单0 - 》 待提货1 -》已提货2 -》待送达2 -》已送达3 -》已取消4
            // var n = {
            //   img: '../../static/order/s1.png',
            //   time: res.data.data.create_time,
            //   title: 'Shipment created',
            //   status: 0,
            //   address: "In system"
            // };
            // var n1 = {
            //   img: '../../static/order/s2.png',
            //   time: "",
            //   title: 'Wait for picked up',
            //   status: 1,
            //   address: res.data.data.from_area
            // };
            // var n2 = {
            //   img: '../../static/order/s2.png',
            //   time: res.data.data.get_time,
            //   title: 'Picked up',
            //   status: 2,
            //   address: res.data.data.from_area
            // };
            // var n3 = {
            //   img: '../../static/order/s4.png',
            //   time: "",
            //   title: 'In Transit',
            //   status: 3,
            //   address: res.data.data.to_area
            // };
            // var n4 = {
            //   img: '../../static/order/s6.png',
            //   time: res.data.data.send_time,
            //   status: 4,
            //   title: 'Delivered',
            //   url: [res.data.data.sign_user_img]
            // };
            // var n5 = {
            //   img: '../../static/order/s7.png',
            //   time: res.data.data.cancel_time,
            //   status: 5,
            //   title: 'Cancelled',
            // };
            // if (res.data.data.status == 0) { // 0=待分配
            //   this.dataList = [n];
            // }
            // if (res.data.data.status == 1) { // 1=待提货
            //   // this.dataList = [n, n0, n0s, n1, n1s, n2, n3, n4];
            //   this.dataList = [n, n1];
            // }
            // if (res.data.data.status == 2) { // 2=送货中
            //   this.dataList = [n, n2, n3];
            // }
            // if (res.data.data.status == 3) { // 3=已完成
            //   this.dataList = [n, n2, n3, n4];
            // }
            // if (res.data.data.status == 4) { // 4=已取消
            //   this.dataList = [n, n5];
            // }
            this.detail = res.data.data;
            // this.dataList = res.data.data.trajectory;
            // this.dataList = [n, n1, n2, n3, n4, n5];
            this.loading = false;
          } else {
            this.loading = false;
            this.$message({
              message: 'No order',
              type: 'wraning'
            })
          }
        }).catch(err => {
          this.loading = false;
        })
      }
    }
  }
</script>

<style scoped="scoped">
  .page {
    width: 100%;
    font-size: 12px;
  }

  @media only screen and (min-width:1200px) {

    /* 订单查询 start */
    .tracking {
      margin-top: 72px;
      text-align: center;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .Search-wrap {
      opacity: 1;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      height: 56px;
      align-items: center;
      margin-top: 32px;
    }

    .Search {
      width: 686px;
      height: 56px;
      opacity: 1;
      border-radius: 8px 0 0 8px;
      border: none;
      font-size: 20px;
      color: #333333;
      font-weight: 600;
    }

    .Search>>>.el-input__inner {
      height: 56px;
      background: #E5E7EB;
    }


    .TRACK {
      width: 196px;
      height: 56px;
      border: 1px solid #EEEEEE;
      background: linear-gradient(86deg, #0282CA 0%, #1F499E 100%);
      opacity: 1;
      border-radius: 0 3px 3px 0;
      color: #FFFFFF !important;
      display: block;
    }

    .TRACK>>>span {
      font-size: 26px;
    }

    /* 订单查询 end */

    .more {
      height: 47px;
      width: 1200px;
      margin: 104px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .more-left {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .more-right {
      display: flex;
      align-items: center;
    }

    .more-right span {
      font-size: 28px;
      font-weight: 400;
      font-family: Microsoft YaHei;
      color: #666666;
      margin-right: 10px;
    }

    .more-icon {
      margin-top: 5px;
      width: 12px;
      height: 16px;
    }

    .video {
      display: block;
      width: 1200px;
      margin: 32px auto 0;
    }

    .video-text {
      margin: 32px auto 0;
      width: 1200px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 56px;
      color: #666666;
      opacity: 1;
    }

    /* Contact us start */


    .el-input__inner {
      height: 56px;
    }

    /* Contact us end */


    .TopLogistics {
      margin: 130px auto;
      text-align: center;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #9EA7B7;
      opacity: 1;
    }

    .list {
      margin-top: 54px;
      margin-bottom: 50px;
    }

    .list-title {
      width: 886px;
      border-bottom: solid 1px #c7c7c7;
      height: 60px;
      margin: 0 auto;
      line-height: 60px;
      font-size: 28px;
      font-weight: bold;
    }

    .item {
      width: 886px;
      margin: 0 auto;
      position: relative;
      border-bottom: solid 1px #c7c7c7;
      height: 80px;
      transition: ease 0.3s;
    }

    .item-list {
      height: 80px;
      display: flex;
      justify-content: space-between;
    }

    .itemActive {
      height: 230px !important;

    }

    .item:hover {
      /* background-color: #EEEEEE; */
    }

    .item-left {
      height: 100%;
      display: flex;
      align-items: center;
      width: 250px;
      position: relative;
    }

    .item-left-solid {
      top: -20px;
      width: 34px;
      height: 40px;
      position: absolute;
    }

    .jiantou {
      width: 12px;
      height: 12px;
      transition: ease 0.3s;
      transform: rotate(0deg)
    }

    .jiantouActive {
      transform: rotate(180deg);
    }

    .item-left-tex-wrap {
      width: 34px;
      height: 34px;
      background: #0282CA;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }

    .item-left-text {
      width: 24px;
      height: 24px;
      opacity: 1;
      position: relative;
    }

    /* .item-left-solid {
      position: absolute;
      border-left: dashed #999999 1px;
      top: 0;
      bottom: 0;
      left: 44px;
    } */

    .item-right {
      width: 570px;
      /* padding-bottom: 98px; */
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    .item-left .item-right-title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 25px;
      color: #333333;
      opacity: 1;
      font-weight: bold;
    }

    .item-img {
      margin-top: 20px;
      display: flex;
      flex-flow: row wrap;
    }

    .item-img-pre {
      height: 120px;
      margin-right: 30px;
      margin-bottom: 30px;
    }

    .order-time {
      /* margin-top: 16px; */
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: #666;
      font-weight: 400;
      opacity: 1;
      flex: 1;
      text-align: center;
    }

    .order-no {
      /* margin-top: 16px; */
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: #333333;
      font-weight: 700;
      opacity: 1;
      flex: 1;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .order-no span {
      margin-right: 5px;
    }
  }

  @media only screen and (min-width:768px) and (max-width: 1199px) {

    /* 订单查询 start */
    .tracking {
      margin-top: 72px;
      text-align: center;
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .Search-wrap {
      opacity: 1;
      border-radius: 8px;
      display: flex;
      justify-content: center;
      height: 56px;
      align-items: center;
      margin-top: 32px;
    }

    .Search {
      width: 686px;
      height: 56px;
      opacity: 1;
      border-radius: 8px 0 0 8px;
      border: none;
      font-size: 20px;
      color: #333333;
      font-weight: 600;
    }

    .Search>>>.el-input__inner {
      height: 56px;
      background: #E5E7EB;
    }


    .TRACK {
      width: 196px;
      height: 56px;
      border: 1px solid #EEEEEE;
      background: linear-gradient(86deg, #0282CA 0%, #1F499E 100%);
      opacity: 1;
      border-radius: 0 3px 3px 0;
      color: #FFFFFF !important;
      display: block;
    }

    .TRACK>>>span {
      font-size: 26px;
    }

    /* 订单查询 end */

    .more {
      height: 47px;
      width: 1200px;
      margin: 104px auto 0;
      display: flex;
      justify-content: space-between;
    }

    .more-left {
      font-size: 36px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 47px;
      color: #333333;
      opacity: 1;
    }

    .more-right {
      display: flex;
      align-items: center;
    }

    .more-right span {
      font-size: 28px;
      font-weight: 400;
      font-family: Microsoft YaHei;
      color: #666666;
      margin-right: 10px;
    }

    .more-icon {
      margin-top: 5px;
      width: 12px;
      height: 16px;
    }

    .video {
      display: block;
      width: 1200px;
      margin: 32px auto 0;
    }

    .video-text {
      margin: 32px auto 0;
      width: 1200px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 56px;
      color: #666666;
      opacity: 1;
    }

    /* Contact us start */


    .el-input__inner {
      height: 56px;
    }

    /* Contact us end */


    .TopLogistics {
      margin: 130px auto;
      text-align: center;
      height: 28px;
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #9EA7B7;
      opacity: 1;
    }

    .list {
      margin-top: 54px;
      margin-bottom: 50px;
    }

    .list-title {
      width: 886px;
      border-bottom: solid 1px #c7c7c7;
      height: 60px;
      margin: 0 auto;
      line-height: 60px;
      font-size: 28px;
      font-weight: bold;
    }

    .item {
      width: 886px;
      margin: 0 auto;
      position: relative;
      border-bottom: solid 1px #c7c7c7;
      height: 80px;
      transition: ease 0.3s;
    }

    .item-list {
      height: 80px;
      display: flex;
      justify-content: space-between;
    }

    .itemActive {
      height: 230px !important;

    }

    .item:hover {
      /* background-color: #EEEEEE; */
    }

    .item-left {
      height: 100%;
      display: flex;
      align-items: center;
      width: 250px;
      position: relative;
    }

    .item-left-solid {
      top: -20px;
      width: 34px;
      height: 40px;
      position: absolute;
    }

    .jiantou {
      width: 12px;
      height: 12px;
      transition: ease 0.3s;
      transform: rotate(0deg)
    }

    .jiantouActive {
      transform: rotate(180deg);
    }

    .item-left-tex-wrap {
      width: 34px;
      height: 34px;
      background: #0282CA;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }

    .item-left-text {
      width: 24px;
      height: 24px;
      opacity: 1;
      position: relative;
    }

    /* .item-left-solid {
     position: absolute;
     border-left: dashed #999999 1px;
     top: 0;
     bottom: 0;
     left: 44px;
   } */

    .item-right {
      width: 570px;
      /* padding-bottom: 98px; */
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    .item-left .item-right-title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 25px;
      color: #333333;
      opacity: 1;
      font-weight: bold;
    }

    .item-img {
      margin-top: 20px;
      display: flex;
      flex-flow: row wrap;
    }

    .item-img-pre {
      height: 120px;
      margin-right: 30px;
      margin-bottom: 30px;
    }

    .order-time {
      /* margin-top: 16px; */
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: #666;
      font-weight: 400;
      opacity: 1;
      flex: 1;
      text-align: center;
    }

    .order-no {
      /* margin-top: 16px; */
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: #333333;
      font-weight: 700;
      opacity: 1;
      flex: 1;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .order-no span {
      margin-right: 5px;
    }
  }

  @media only screen and (max-width: 767px) {

    /* 订单查询 start */
    .tracking {
      margin-top: 0.72rem;
      text-align: center;
      font-size: 0.36rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.47rem;
      color: #333333;
      opacity: 1;
    }

    .Search-wrap {
      opacity: 1;
      border-radius: 0.08rem;
      display: flex;
      justify-content: center;
      /* height: 0.56rem; */
      align-items: center;
      margin-top: 0.32rem;
    }

    .Search {
      width: 6.86rem;
      /* height: 0.56rem; */
      opacity: 1;
      border-radius: 0.08rem 0 0 0.08rem;
      border: none;
      font-size: 0.28rem;
      color: #333333;
      font-weight: 600;
    }

    .Search>>>.el-input__inner {
      /* height: 0.56rem; */
      background: #E5E7EB;
    }


    .TRACK {
      width: 1.96rem;
      /* height: 0.79rem; */
      /* border: 0.01rem solid #EEEEEE; */
      background: linear-gradient(86deg, #0282CA 0%, #1F499E 100%);
      opacity: 1;
      border-radius: 0 0.03rem 0.03rem 0;
      color: #FFFFFF !important;
      display: block;
    }

    .TRACK>>>span {
      /* font-size: 0.26rem; */
    }

    /* 订单查询 end */

    .more {
      height: 0.47rem;
      width: 90%;
      margin: 1.04rem auto 0;
      display: flex;
      justify-content: space-between;
    }

    .more-left {
      font-size: 0.36rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.47rem;
      color: #333333;
      opacity: 1;
    }

    .more-right {
      display: flex;
      align-items: center;
    }

    .more-right span {
      font-size: 0.28rem;
      font-weight: 400;
      font-family: Microsoft YaHei;
      color: #666666;
      margin-right: 0.1rem;
    }

    .more-icon {
      margin-top: 0.05rem;
      width: 0.12rem;
      height: 0.16rem;
    }

    .video {
      display: block;
      width: 90%;
      margin: 0.32rem auto 0;
    }

    .video-text {
      margin: 0.32rem auto 0;
      width: 90%;
      font-size: 0.32rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.56rem;
      color: #666666;
      opacity: 1;
    }

    /* Contact us start */


    .el-input__inner {
      height: 0.56rem;
    }

    /* Contact us end */


    .TopLogistics {
      margin: 1.3rem auto;
      text-align: center;
      height: 0.28rem;
      font-size: 0.28rem;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0.28rem;
      color: #9EA7B7;
      opacity: 1;
    }

    .list {
      margin-top: 0.54rem;
      margin-bottom: 0.5rem;
    }

    .list-title {
      width: 90%;
      border-bottom: solid 1px #c7c7c7;
      height: 0.6rem;
      margin: 0 auto;
      line-height: 0.6rem;
      font-size: 0.32rem;
      font-weight: bold;
    }

    .item {
      width: 90%;
      margin: 0 auto;
      position: relative;
      border-bottom: solid 1px #c7c7c7;
      height: 1.6rem;
      transition: ease 0.3s;
    }

    .item-list {
      height: 1.6rem;
      display: flex;
      justify-content: space-between;
    }

    .itemActive {
      height: 3.2rem !important;

    }

    .item:hover {
      /* background-color: #EEEEEE; */
    }

    .item-left {
      height: 100%;
      display: flex;
      align-items: center;
      width: 2.5rem;
      position: relative;
    }

    .item-left-solid {
      top: -0.4rem;
      width: 0.4rem;
      height: 0.8rem;
      left: 0.1rem;
      position: absolute;
    }

    .jiantou {
      width: 0.12rem;
      height: 0.12rem;
      transition: ease 0.3s;
      transform: rotate(0deg)
    }

    .jiantouActive {
      transform: rotate(180deg);
    }

    .item-left-tex-wrap {
      width: 0.68rem;
      height: 0.68rem;
      background: #0282CA;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.1rem;
    }

    .item-left-text {
      width: 0.48rem;
      height: 0.48rem;
      opacity: 1;
      position: relative;
    }

    /* .item-left-solid {
     position: absolute;
     border-left: dashed #999999 1px;
     top: 0;
     bottom: 0;
     left: 44px;
   } */

    .item-right {
      width: 5.7rem;
      /* padding-bottom: 98px; */
      display: flex;
      justify-content: space-around;
      align-items: center;
    }

    .item-left .item-right-title {
      font-size: 0.30rem;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0.35rem;
      color: #333333;
      opacity: 1;
      font-weight: bold;
      flex: 1;
    }

    .item-img {
      margin-top: 0.2rem;
      display: flex;
      flex-flow: row wrap;
    }

    .item-img-pre {
      height: 1.2rem;
      margin-right: 0.3rem;
      margin-bottom: 0.3rem;
    }

    .order-time {
      /* margin-top: 16px; */
      font-size: 0.28rem;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0.35rem;
      color: #666;
      font-weight: 400;
      opacity: 1;
      flex: 1;
      text-align: center;
    }

    .order-no {
      /* margin-top: 16px; */
      font-size: 0.28rem;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0.35rem;
      color: #333333;
      font-weight: 700;
      opacity: 1;
      flex: 1;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .order-no span {
      margin-right: 0.05rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/tracking.vue